import { Controller } from '@hotwired/stimulus'

/**
 * OnChangeFormSubmitter
 *
 * Submits the closest form when a bound input fires a change event.
 */
export default class extends Controller {
    submit(event) {
        const target = event && event.target ? event.target : null
        let form = null

        if (target) {
            if (typeof target.closest === 'function') {
                form = target.closest('form')
            }

            if (!form && target.form) {
                form = target.form
            }
        }

        if (!form) {
            form = this.element.closest('form')
        }

        if (!form) return

        if (typeof form.requestSubmit === 'function') {
            form.requestSubmit()
        } else {
            form.submit()
        }
    }
}
